import produce from 'immer';

import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  UPDATE_COUNTRY_SUCCESS,
} from 'actions/countryActions';

export const initialState = {
  list: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
};

/* eslint-disable default-case, no-param-reassign */
const countryReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_COUNTRIES:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        draft.list = [];
        break;
      case FETCH_COUNTRIES_SUCCESS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        draft.list = action.countries;
        break;
      case UPDATE_COUNTRY_SUCCESS:
        draft.list = draft.list.map((country) =>
          country._id === action.country._id ? action.country : country
        );
        break;
    }
  });

export default countryReducer;
